module.exports = __webpack_public_path__ + "img/admin_logo.e23f241c.svg";